import { connect } from 'react-redux'
import { fetchServicing } from '../../actions/servicings'
import { goBack } from 'react-router-redux'
import get from 'lodash/get'

import ServicingImages from '../../components/servicings/servicing-images'

function mapStateToProps (state, { params: { servicingId } }) {
  const servicing = get(state, `servicings.${servicingId}`)
  if (!servicing) return { loading: true }

  return {
    servicing,
    modalTitle: 'Before/After Images',
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { servicingId } = ownProps.params
  dispatch(fetchServicing(servicingId))

  return {
    handleClose () {
      dispatch(goBack())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ServicingImages)



// WEBPACK FOOTER //
// ./src/containers/servicings/servicing-images-container.js